import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import MembersGroupName from "../../components/membersGroup/MembersGroupDetail/MembersGroupName.tsx";
import {useLocationFormState} from "../../components/membersGroup/MembersGroupForm/MembersGroupUpdateForm";
import MembersGroupUpdateFormProvider from "../../components/membersGroup/MembersGroupForm/MembersGroupUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const MembersGroupUpdateEditPage = () => {
    
    useTitle(t`Update Members Group`);

    const { membersGroupId: id } = useParams();
    
    return (
        <Box data-testid="MembersGroup-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="MembersGroup-update-title"
                    >
                        <Trans>Edit Members Group</Trans>:  <MembersGroupName id={id}/>
                    </Typography>
                    <MembersGroupUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default MembersGroupUpdateEditPage;
